import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Rule } from '../../../utilities/schemas/rules';

export interface MultipleIpCountriesParams {
  lookbackPeriod: { amount: number; unit: string };
  includeAnonymousIps: boolean;
}

const MultipleIpCountries = ({ rule }: {
  rule: Rule;
}) => {
  const { lookbackPeriod, includeAnonymousIps } = rule
    .ruleParameters as MultipleIpCountriesParams;

  return (
    <>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
          <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
            Lookback period
          </Typography>
          <Typography fontSize={10}>
            {`${lookbackPeriod.amount} ${lookbackPeriod.unit}`}
          </Typography>
        </Box>
      </Grid>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
          <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
            Include anonymous IPs
          </Typography>
          <Typography fontSize={10}>
            {includeAnonymousIps ? 'Yes' : 'No'}
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default MultipleIpCountries;
